import config from '../config';

export function getServerURL() {
    let serverUrl =
        localStorage.getItem('serverUrl') != '' ? localStorage.getItem('serverUrl') : `${config.api.urlHost}${config.api.basePath}`;
    return serverUrl;
}

export function getAPIToken() {
    return localStorage.getItem('token') ? localStorage.getItem('token') : null;
}
